<xemex-card
  [title]="'home.alarmsWidget.title' | translate"
  titleSize="lg"
  [actionLabel]="'home.viewAll' | translate"
  (action)="viewAll.emit()"
>
  <div class="flex flex-col gap-5">
    <div class="flex items-center justify-center gap-10 py-1">
      <span class="text-5xl font-bold">{{ total() }}</span>
      <div class="w-[180px] h-[180px] flex-none">
        <canvas
          baseChart
          class="h-full w-full cursor-pointer"
          [type]="'pie'"
          [data]="chartData()"
          [options]="chartOptions"
          role="img"
          [attr.aria-label]="'home.alarmsWidget.title' | translate"
          (chartHover)="onChartHover($event)"
          (chartClick)="onChartClick($event)"
        ></canvas>
      </div>
      <div class="flex flex-col gap-2">
        @for (wedge of priorityWedges(); track wedge.priority) {
          <div
            class="flex items-center gap-2 cursor-pointer transition-opacity"
            [style.opacity]="hoveredPriority() && hoveredPriority() !== wedge.priority ? 0.55 : 1"
            (mouseenter)="hoveredPriority.set(wedge.priority)"
            (mouseleave)="hoveredPriority.set(null)"
            (click)="priorityFilterClick.emit(wedge.priority)"
          >
            <span class="w-2 h-2 rounded-full" [style.background]="wedge.color"></span>
            <span class="text-sm">{{ wedge.label }}</span>
            <span class="text-sm font-bold">{{ wedge.count }}</span>
          </div>
        }
      </div>
    </div>
    <div class="border-t border-border-strong/50"></div>
    <div class="flex flex-col gap-1.5">
      @for (type of byType(); track type.group) {
        <div
          class="flex flex-col gap-1 cursor-pointer hover:bg-surface-hover rounded px-1 -mx-1 py-0.5"
          (click)="typeFilterClick.emit(type.label)"
        >
          <div class="flex items-center justify-between gap-2">
            <span class="text-xs">{{ type.label }}</span>
            <span class="text-xs font-bold">{{ type.count }}</span>
          </div>
          <div class="h-1.5 rounded-full bg-surface-hover overflow-hidden">
            <div class="h-full flex" [style.width.%]="(type.count / maxTypeCount()) * 80">
              @for (segment of type.segments; track segment.priority) {
                <div
                  class="h-full"
                  [style.width.%]="(segment.count / type.count) * 100"
                  [style.background]="segment.color"
                ></div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</xemex-card>
